import type { TicketingSystem } from "@/domain/ticketing"

// Rows that only know a ticket exists, not where it lives
export const UNKNOWN_TICKET_SYSTEMS: TicketingSystem[] = ["jira"]
